export const dummyPartnerIds = {
  DefaultAssociatedPartner: -1,
  RealBeneficiaryAssociatedPartner: -2
};
